// extracted by mini-css-extract-plugin
export var centerText = "_dz-8";
export var container = "_dz-0";
export var doughnutContainer = "_dz-7";
export var legend = "_dz-a";
export var legendItemColorDisplay = "_dz-b";
export var legendItemLabel = "_dz-d";
export var legendItemValue = "_dz-c";
export var lg = "_dz-5";
export var maxWidth = "_dz-9";
export var md = "_dz-4";
export var responsive = "_dz-6";
export var sm = "_dz-3";
export var xs = "_dz-2";
export var xxs = "_dz-1";